<div class="card mb-3 pointer" (click)="openTicketingDetailsPage($event)" >
    <div class="row">
      <div class="col col-3 d-flex align-items-center">
          <img
          [src]="img"
          alt="Ticketing Campaign Image"
          class="img-fluid rounded-start"
          style="height: 110px; width: 220px; border-radius: 4px;"
          />
      </div>
      <div class="col-9 d-flex justify-content-between">
        <div class="d-flex flex-column justify-content-between" style="gap:13px">
          <div class="d-flex align-items-center">
            <h5 class="subtitle-1 mb-0">{{selectedTicketingCampaign?.name}}</h5>
            <i class="fas fa-chevron-right ml-2 pointer"></i>
          </div>
          
          @if(eventStartFormattedDate){
            <div class="event-datetime"> 
              <div class="event-datetime__date">{{eventStartFormattedDate.day}} {{eventStartFormattedDate.month}}</div>
              <div class="event-datetime__time">{{eventStartFormattedDate.time}} {{userTimeZone}}</div>
            </div>
          }

          <div class="d-flex">
            <div class="d-flex align-items-center justify-content-center">
              <div
              class="caption custom-badge"
              [ngClass]="{
                'badge-success': statusType === 'Active',
                'badge-warning': statusType === 'Hidden' || statusType === 'Not started',
                'custom-badge-secondary': statusType === 'Ended' || statusType === 'Deactivated'
              }"
              >
              {{ statusType }}
              </div>
            </div>
            
            @if(typeData?.ticketStats){
              <div class="d-flex mx-4">
                @if(typeData.guestRequired){
                  <div class="body-2 mr-4 align-content-center">
                  <!-- {{guestCount}}/{{totalGuestCount}} guests -->
                    {{typeData.ticketStats.checkedInQuantity}} checked in
                  </div>
                }
  
                <div class="body-2 align-content-center">
                  {{typeData.ticketStats.totalQuantity}} tickets
                </div>
              </div>
            }

            @if(typeData.basketRaffleWinners?.length > 0 || typeData.raffleWinners?.length > 0){
              <button (click)="onShowWinnersClick()" type="button" placement="bottom" trigger="click" class="d-flex body-2 noDetaisClick p-0 align-items-center" style="background-color: white; border: none; color: #0076FF;"> Saved winners </button>
            }
          </div>
        </div>
        <div class="pl-2 d-flex flex-column justify-content-between">
          <div class="pr-2">
            <div class="cursor--pointer noDetaisClick d-flex justify-content-end mb-2" (click)="onSettingsModalOpen()">
              <i data-toggle="tooltip" data-placement="top" title="View Settings" class="fa fa-cog noDetaisClick"></i>
            </div>
            @if(linkedEvent){
              <div class="event-type--connected green-text no-wrap">● Connected to {{eventType}} event </div>
              <div class="event-name--connected text-right no-wrap">{{linkedEvent.name}}</div>
            }
           
          </div>
          <div class="d-flex flex-column justify-content-end mt-4">
            <ul class="d-flex flex-row justify-content-end actions-list list-group noDetaisClick" style="height: 36px;">
              @if(showConnectToEventButton){
                <li (click)="onConnectEvent()" class="list-group-item display-flex px-2 mr-2 pointer noDetaisClick no-wrap">
                  <i class="black-text fas fa-link mt-0 pointer"></i>
                  <span class="ml-2 body-1 noDetaisClick pointer">Connect To Event</span>
                </li>
              }
             
              @if(typeData.isRaffleTicket){
                <li (click)="onDrawModalClick()" class="list-group-item display-flex px-2 mr-2 pointer noDetaisClick no-wrap"
                >
                  <i class="fas fa-trophy pointer"></i>
                  <span class="ml-2 body-1 noDetaisClick pointer">Draw winner</span>
                </li>
              }

              <li class=" display-flex pointer noDetaisClick">
                <app-tickets-and-guests-tabs-popover [ticketingCampaign]="selectedTicketingCampaign"></app-tickets-and-guests-tabs-popover>
              </li>
          </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  